export default __webpack_public_path__ + "img/footer-490aff04.png";